/**
 * @desc 保存成交公告
 */
import {
  AnnouncementEntity,
  TransactionAnnouncementForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateTransactionAnnouncementParameter = TransactionAnnouncementForm

const method = 'POST'
const url = '/trade/operation/announcement/transaction'

export const createTransactionAnnouncementApi = (
  data?: CreateTransactionAnnouncementParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AnnouncementEntity>({
    method,
    url,
    data,
    ...config
  })
}

createTransactionAnnouncementApi.method = method
createTransactionAnnouncementApi.url = url
